/* Copyright (c) Epiphyte LLC 2022. All rights reserved.
Author: Fernandez-Alcon, Jose <jose@epiphyte.io>
 */

import React, { useEffect, useRef, useState  } from "react";
import ReactDOMServer from "react-dom/server";

import {
    Box,
    Grid, Heading,
    Page,
    PageContent,
} from 'grommet';
import { PageHeader } from 'grommet/components/PageHeader'


import mapboxgl from "mapbox-gl";
import {searchProduce} from "API/Search";
import SearchProduceCard from "Components/Produce/SearchProduceCard";

type Props = {}

/**
 * Converts a veggit produce list to GeoJSON FeatureCollection
 * @param produceList
 */
const convertToGeoJSON = (produceList) => {
    let features = []
    produceList.map( prod => {
        let feature = {
            "type" : "Feature",
            "properties" : prod,
            "geometry" : prod.Location
        }
        features.push(feature)
    } )

    return {
        "type": "FeatureCollection",
        "features": features
    }
}


const renderProducePopup = (prod) => {
    return ReactDOMServer.renderToString(
        <SearchProduceCard refreshFunc={null} {... prod}/>
    )
}

const Search: React.FC<Props> = (props) => {
    const mapContainer = useRef(null);
    const map = useRef(null);
    const [lng, setLng] = useState(-71.1);
    const [lat, setLat] = useState(42.35);
    const [zoom, setZoom] = useState(9);
    const [produceList, setProduceList] = useState<Array<any>>([])

    const markerHeight = 50;
    const markerRadius = 10;
    const linearOffset = 25;
    const popupOffsets = {
        'top': [0, 0],
        'top-left': [0, 0],
        'top-right': [0, 0],
        'bottom': [0, -markerHeight],
        'bottom-left': [linearOffset, (markerHeight - markerRadius + linearOffset) * -1],
        'bottom-right': [-linearOffset, (markerHeight - markerRadius + linearOffset) * -1],
        'left': [markerRadius, (markerHeight - markerRadius) * -1],
        'right': [-markerRadius, (markerHeight - markerRadius) * -1]
    };

    mapboxgl.accessToken = "pk.eyJ1IjoiZXBpcGh5dGUtamZhIiwiYSI6ImNsNGxtbDF4MjBqZ3MzZG12MmhmdGdkNjAifQ.WM0PDcw8340uK3KnfeFI3w"
    useEffect(() => {
        if (map.current) return; // initialize map only once
        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/streets-v11',
            center: [lng, lat],
            zoom: zoom
        });

        console.log([lat, lng])
        searchProduce(lng, lat, 1000000).then( produceList => {
            setProduceList(produceList)


            // produceList.map((produce) => {
            //     new mapboxgl.Marker().setLngLat(produce.Location.coordinates).addTo(map.current)
            // })

        });convertToGeoJSON(produceList)

    });


    if (map.current != null) {
        map.current.on('load', () => {
            const pList = convertToGeoJSON(produceList)
            console.log(pList)
            map.current.addSource('produce', {
                'type': 'geojson',
                'data': pList
            } )

            // Add a layer showing the places.
            map.current.addLayer({
                'id': 'produce',
                'type': 'circle',
                'source': 'produce',
                'paint': {
                    'circle-color': '#4264fb',
                    'circle-radius': 6,
                    'circle-stroke-width': 2,
                    'circle-stroke-color': '#ffffff'
                }
            });

            // Create a popup, but don't add it to the map yet.
            const popup = new mapboxgl.Popup({
                closeButton: false,
                closeOnClick: false
            });

            map.current.on('mouseenter', 'produce', (e) => {
            // Change the cursor style as a UI indicator.
                map.current.getCanvas().style.cursor = 'pointer';

                // Copy coordinates array.
                const coordinates = e.features[0].geometry.coordinates.slice();
                const prod = e.features[0].properties;

                // Ensure that if the map is zoomed out such that multiple
                // copies of the feature are visible, the popup appears
                // over the copy being pointed to.
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }

                // Populate the popup and set its coordinates
                // based on the feature found.
                popup.setLngLat(coordinates).setHTML(renderProducePopup(prod)).addTo(map.current);
            });

            map.current.on('mouseleave', 'produce', () => {
                map.current.getCanvas().style.cursor = '';
                popup.remove();
            });

        })
    }



    return  (
            <Page kind={"wide"}>
                <PageHeader
                    title="Search Produce"
                    subtitle="Look for VeggIt home producers in your area!"
                    margin={"medium"}
                    // parent={<Anchor label="Parent Page" />}
                    // actions={<Button label="Add produce" primary />}
                />
                 <PageContent>
                     {/*<SearchLocationInput />*/}

                     <div ref={mapContainer} className="map-container" />

                     <Box>
                         <Heading level={2} >Veggies Near Me</Heading>
                         <Grid
                             rows={'medium'}
                             columns={'small'}
                             gap={"xsmall"}
                         >
                             {produceList.map( (prod) =>  <SearchProduceCard refreshFunc={null} {... prod}/>) }

                         </Grid>
                         </Box>
                 </PageContent>
            </Page>

    )
}

export default Search
